// extracted by mini-css-extract-plugin
export default {"navigationItemContent":"ProfilePage_navigationItemContent__UF2ok","active":"ProfilePage_active__kplUG","navigationItemIcon":"ProfilePage_navigationItemIcon__oiCZX"};